import React from 'react';

// Country codes for flagcdn.com (aligned with `Layout.js`)
const LANG_META = {
  en: { country: 'gb', name: 'English' },
  es: { country: 'es', name: 'Spanish' },
  pt: { country: 'br', name: 'Portuguese' },
  fr: { country: 'fr', name: 'French' },
  de: { country: 'de', name: 'German' },
  it: { country: 'it', name: 'Italian' },
  ru: { country: 'ru', name: 'Russian' },
  zh: { country: 'cn', name: 'Mandarin' },
  ja: { country: 'jp', name: 'Japanese' },
  ko: { country: 'kr', name: 'Korean' },
  ar: { country: 'sa', name: 'Arabic' },
  hi: { country: 'in', name: 'Hindi' },
  tr: { country: 'tr', name: 'Turkish' },
  fa: { country: 'ir', name: 'Persian' },
  ps: { country: 'af', name: 'Pashto' },
  vi: { country: 'vn', name: 'Vietnamese' },
  id: { country: 'id', name: 'Indonesian' },
  sw: { country: 'ke', name: 'Swahili' },
  xh: { country: 'za', name: 'Xhosa' },
  th: { country: 'th', name: 'Thai' },
  nl: { country: 'nl', name: 'Dutch' },
  pl: { country: 'pl', name: 'Polish' },
  sv: { country: 'se', name: 'Swedish' },
  he: { country: 'il', name: 'Hebrew' },
  el: { country: 'gr', name: 'Greek' },
  uk: { country: 'ua', name: 'Ukrainian' },
  cs: { country: 'cz', name: 'Czech' },
};

export default function LanguageFlag({ code, size = 'sm', showLabel = false }) {
  const meta = LANG_META[(code || '').toLowerCase()];
  const dim = size === 'lg' ? 'w-6 h-5' : size === 'md' ? 'w-5 h-[14px]' : 'w-4 h-3';

  if (!meta) {
    return (
      <span className="text-[10px] font-mono uppercase opacity-70">{code}</span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={`flag-${code}`}>
      <img
        src={`https://flagcdn.com/w40/${meta.country}.png`}
        srcSet={`https://flagcdn.com/w80/${meta.country}.png 2x`}
        alt={meta.name}
        className={`${dim} object-cover rounded-sm shadow-sm`}
        loading="lazy"
      />
      {showLabel && <span className="text-xs text-muted-foreground">{meta.name}</span>}
    </span>
  );
}

export { LANG_META };
